import { ReactNode, useState } from 'react';
import BackofficeSidebar from './BackofficeSidebar';
import BackofficeHeader from './BackofficeHeader';

interface BackofficeLayoutProps {
  children: ReactNode;
}

export default function BackofficeLayout({ children }: BackofficeLayoutProps) {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  return (
    <div className="flex h-screen bg-gray-50">
      <BackofficeSidebar
        isCollapsed={isSidebarCollapsed}
        onToggle={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
      />
      <div className="flex-1 flex flex-col overflow-hidden min-w-0">
        <BackofficeHeader onToggleSidebar={() => setIsSidebarCollapsed(!isSidebarCollapsed)} />
        <main className="flex-1 overflow-y-auto p-6">
          {children}
        </main>
      </div>
    </div>
  );
}